import type { SnapPointsConfig } from './store'

export default {
  mb: {
    micro: '72px',
    full: '600px' 
  },

  dt: {
    micro: '90px',
    full: '620px' 
  }
} satisfies SnapPointsConfig
